module.exports = __webpack_public_path__ + "static/website_banner-883a68e7c685a03dc19016eb52b27172.png";